<app-dialog-title
  [title]="'sandbox.unlock-dialog.title' | translate"
  (closeDialog)="close()">
</app-dialog-title>

<div class="content g-flex-column">
  <div>{{ 'sandbox.unlock-dialog.header' | translate }}</div>
  <div class="margin-top-60 color-yellow-fire">{{ 'sandbox.unlock-dialog.list.title' | translate }}</div>
  <ul class="text-left color-yellow-fire">
    <li>{{ 'sandbox.unlock-dialog.list.item-1' | translate }}</li>
    <li>{{ 'sandbox.unlock-dialog.list.item-2' | translate }}</li>
    <li>{{ 'sandbox.unlock-dialog.list.item-3' | translate }}</li>
    <li>{{ 'sandbox.unlock-dialog.list.item-4' | translate }}</li>
    <li>{{ 'sandbox.unlock-dialog.list.item-5' | translate }}</li>
    <li>{{ 'sandbox.unlock-dialog.list.item-6' | translate }}</li>
  </ul>
</div>

<div class="g-flex g-flex--justify-center">
  <div class="g-flex g-flex--align-center">
    @if (heroTokenType) {
      <img
        [attr.src]="'assets/images/ui/icons/tokens/' + heroTokenType + '.png'"
        alt="token" />
    }
    <div class="text-left color-yellow-fire">
      <span> {{ payAmount$ | async }} </span>
      <span> (${{ payAmountUsd$ | async }}) </span>
    </div>
  </div>
</div>

<div class="controls g-flex g-flex--align-center g-flex--justify-center g-flex--wrap">
  @if (isAllowance$ | async) {
    <button
      class="app-btn-red-2"
      appButtonClick
      [infoDesc]="'hero-name-dialog.buttons.no-balance' | translate"
      [isDisabled]="!hasBalance"
      [disabled]="isLoading$ | async"
      (hostClick)="unlock()">
      @if (isLoading$ | async) {
        <app-loading-small />
      } @else {
        {{ 'sandbox.unlock-dialog.unlock' | translate }}
      }
    </button>
  } @else {
    <button
      class="app-btn-red-2"
      appButtonClick
      [isNeedConfirm]="true"
      (hostClick)="approve()">
      {{ 'hero-name-dialog.buttons.approve' | translate }}
    </button>
  }
</div>
